import { render, staticRenderFns } from "./UserPasswordBasic.vue?vue&type=template&id=6e18cd18&scoped=true"
import script from "./UserPasswordBasic.vue?vue&type=script&lang=js"
export * from "./UserPasswordBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e18cd18",
  null
  
)

export default component.exports